module.exports = __webpack_public_path__ + "img/lupa-roja.e94e769e.svg";